import { render } from "./home.vue?vue&type=template&id=5e51a431&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=5e51a431&scoped=true&lang=css"

import exportComponent from "/Users/mac/Documents/GitHub/cristhianVeAl_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e51a431"]])

export default __exports__